// extracted by mini-css-extract-plugin
export var required = "_pr-0";